// extracted by mini-css-extract-plugin
export var contact = "Portfolio-module--contact--fHYIu";